export const MODAL_DIALOG__CREATE_SITE_FOOTER_LINK_CATEGORY = 'MODAL_DIALOG__CREATE_SITE_FOOTER_LINK_CATEGORY';
export const MODAL_DIALOG__EDIT_SITE_FOOTER_LINK_CATEGORY = 'MODAL_DIALOG__EDIT_SITE_FOOTER_LINK_CATEGORY';
export const MODAL_DIALOG__CREATE_SITE_FOOTER_LINK = 'MODAL_DIALOG__CREATE_SITE_FOOTER_LINK';
export const MODAL_DIALOG__EDIT_SITE_FOOTER_LINK = 'MODAL_DIALOG__EDIT_SITE_FOOTER_LINK';
export const MODAL_DIALOG__CREATE_SITE_FOOTER_LINK_TRANSLATION = 'MODAL_DIALOG__CREATE_SITE_FOOTER_LINK_TRANSLATION';
export const MODAL_DIALOG__EDIT_SITE_FOOTER_LINK_TRANSLATION = 'MODAL_DIALOG__EDIT_SITE_FOOTER_LINK_TRANSLATION';
